function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.972 27.084c.009.2 0 .37 0 .572 0 6.568-5.099 11.94-11.599 12.52v11.09h6.96V54.7h-17.4v-3.434h6.959V40.177c-6.5-.579-11.6-5.952-11.6-12.52 0-.165-.006-.408 0-.572h2.898c-.01.188 0 .382 0 .572 0 5.69 4.679 9.501 10.443 9.501 5.764 0 10.442-3.81 10.442-9.5 0-.203.01-.373 0-.573z",
  fill: "#fff",
  stroke: "var(--primary-color, #000)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.092 26.2c0 4.234 3.377 7.666 7.542 7.666s7.541-3.432 7.541-7.666V8.679c0-4.234-3.376-7.666-7.541-7.666s-7.542 3.432-7.542 7.666z",
  fill: "#fff",
  stroke: "var(--primary-color, #000)"
});

var SvgMicrophone = function SvgMicrophone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Microphone.7fb684a1.svg";
export { ForwardRef as ReactComponent };